import React, { useState } from "react";
import { API_URL } from "../helpers";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Step2 = ({ token, email, update }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    token,
    email,
  });
  const [msg, setMsg] = useState({});

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/auth/charitySignin2`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        update("signedinToken", json.token);
        update("step", 3);
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <form
      method="post"
      action="/"
      onSubmit={(e) => handleSubmit(e)}
      className="well"
    >
      <h3 style={{ marginTop: "0" }}>Charity Contacts Access</h3>

      <p>
        Please enter the access code that was emailed to{" "}
        <strong>{names.email}</strong> (note that it may have gone to your spam
        folder).
      </p>

      <div className="form-group">
        <Input
          name="accessCode"
          label="Access Code"
          reqd={true}
          value={names.accessCode || ""}
          update={handleUpdate}
          errors={errors}
        />
        <div />
      </div>

      <div className="msg-submit">
        {msg.type && <Msg data={msg} />}

        <div
          className={
            msg.type === "working" || msg.type === "success"
              ? "hidden"
              : "submit-container"
          }
        >
          <Submit path="" left="" submit="Submit Access Code" />
        </div>
      </div>
    </form>
  );
};

export default Step2;
